import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ChipBox, InfoField } from '@occc-app/design-system';
import { ConstraintStoreLocationFragment, Store_Location_Evaluation_Method } from '@occc/graphql';

type StoreLocationProps = Pick<ConstraintStoreLocationFragment, 'locations' | 'evaluationMethod'>;

export const StoreLocation: React.FC<StoreLocationProps> = ({ locations, evaluationMethod }) => {
  const navigate = useNavigate();
  const onChipClick = React.useCallback(
    (id: string) => {
      navigate(`/locations/${id}`);
    },
    [navigate],
  );
  const mappedLocations = locations.map((location) => ({
    id: location.id,
    name: location?.name || 'Name is not defined',
  }));
  const label = `${
    evaluationMethod === Store_Location_Evaluation_Method.Exclude ? 'excluded' : 'included'
  } locations`;

  return (
    <InfoField
      label={label}
      value={<ChipBox items={mappedLocations} onClick={onChipClick} mt={0} />}
      disableTypography
    />
  );
};
